import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  border-radius: 4px;
  background-color: #fff;
  margin-top: 12px;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  gap: 20px;
  position: relative;
  border: 1px solid #f1f3f5;
  table {
    thead > tr {
      th:last-child {
        min-width: 200px;
        text-align: left;
      }
    }

    tbody {
      tr td:last-child div {
        text-align: left;
      }
    }
  }
`;

export const AccessRowData = styled.div`
  text-align: right;
`;
